module.exports = __webpack_public_path__ + "img/five.ba15a276.png";